"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = { class: "tab-panel medication-pharmacy-panel" };
var _hoisted_2 = {
    key: 0,
    class: "form-group"
};
var _hoisted_3 = {
    class: "pharmacy-list-container",
    style: { "display": "flex", "flex-direction": "column", "gap": "10px", "margin-top": "10px" }
};
var _hoisted_4 = { style: { "flex": "1" } };
var _hoisted_5 = { style: { "font-weight": "600", "color": "#333", "margin-bottom": "4px" } };
var _hoisted_6 = { style: { "font-size": "0.85em", "color": "#666" } };
var _hoisted_7 = { key: 0 };
var _hoisted_8 = {
    key: 1,
    style: { "margin-left": "10px" }
};
var _hoisted_9 = { style: { "display": "flex", "gap": "8px" } };
var _hoisted_10 = ["onClick"];
var _hoisted_11 = { key: 0 };
var _hoisted_12 = { style: { "flex": "1" } };
var _hoisted_13 = { style: { "font-weight": "600", "color": "#333", "margin-bottom": "4px" } };
var _hoisted_14 = { style: { "font-size": "0.85em", "color": "#666" } };
var _hoisted_15 = { key: 0 };
var _hoisted_16 = {
    key: 1,
    style: { "margin-left": "10px" }
};
var _hoisted_17 = { style: { "display": "flex", "gap": "8px" } };
var _hoisted_18 = ["onClick"];
var _hoisted_19 = { class: "form-group" };
var _hoisted_20 = { class: "form-row" };
var _hoisted_21 = {
    class: "form-group",
    style: { "flex": "2" }
};
var _hoisted_22 = {
    class: "form-row",
    style: { "flex-wrap": "wrap" }
};
var _hoisted_23 = {
    class: "form-group",
    style: { "flex": "1 1 calc(50% - 0.5rem)", "min-width": "200px" }
};
var _hoisted_24 = {
    key: 0,
    class: "error-message"
};
var _hoisted_25 = {
    class: "form-group",
    style: { "flex": "1 1 calc(50% - 0.5rem)", "min-width": "200px" }
};
var _hoisted_26 = {
    class: "form-group",
    style: { "flex": "1 1 calc(33.333% - 0.67rem)", "min-width": "100px" }
};
var _hoisted_27 = {
    class: "form-group",
    style: { "flex": "1 1 calc(33.333% - 0.67rem)", "min-width": "120px" }
};
var _hoisted_28 = {
    key: 0,
    class: "pharmacy-hint",
    style: { "color": "#666", "font-size": "0.9em", "margin-bottom": "10px", "padding": "8px", "background-color": "#f0f0f0", "border-radius": "4px", "min-height": "20px" }
};
var _hoisted_29 = ["disabled", "title"];
var _hoisted_30 = {
    key: 1,
    class: "pharmacy-results"
};
var _hoisted_31 = { class: "results-header" };
var _hoisted_32 = {
    key: 0,
    class: "results-sub"
};
var _hoisted_33 = { class: "pharmacy-results-scroll" };
var _hoisted_34 = { style: { "flex": "1", "display": "flex", "align-items": "center", "gap": "12px" } };
var _hoisted_35 = ["onClick", "title"];
var _hoisted_36 = ["onClick"];
var _hoisted_37 = { style: { "display": "flex", "align-items": "center", "gap": "10px", "flex-wrap": "wrap" } };
var _hoisted_38 = { style: { "color": "#333", "font-size": "1em" } };
var _hoisted_39 = {
    class: "pharmacy-npi",
    style: { "color": "#666", "font-size": "0.9em" }
};
var _hoisted_40 = {
    class: "pharmacy-result-address",
    style: { "margin-top": "6px", "color": "#666", "font-size": "0.9em" }
};
var _hoisted_41 = {
    key: 0,
    class: "pharmacy-result-phone",
    style: { "margin-top": "4px", "color": "#666", "font-size": "0.9em" }
};
var _hoisted_42 = { style: { "display": "grid", "grid-template-columns": "repeat(auto-fit, minmax(200px, 1fr))", "gap": "12px", "margin-bottom": "15px" } };
var _hoisted_43 = ["onUpdate:modelValue"];
var _hoisted_44 = ["onUpdate:modelValue"];
var _hoisted_45 = ["onUpdate:modelValue"];
var _hoisted_46 = ["onUpdate:modelValue"];
var _hoisted_47 = ["onUpdate:modelValue"];
var _hoisted_48 = ["onUpdate:modelValue"];
var _hoisted_49 = ["onUpdate:modelValue"];
var _hoisted_50 = ["onUpdate:modelValue"];
var _hoisted_51 = { style: { "display": "flex", "gap": "10px", "justify-content": "flex-end", "border-top": "1px solid #eee", "padding-top": "12px" } };
var _hoisted_52 = ["onClick"];
var _hoisted_53 = ["onClick"];
var _hoisted_54 = ["onClick"];
var _hoisted_55 = {
    key: 0,
    class: "pharmacy-search-pager"
};
var _hoisted_56 = {
    key: 2,
    class: "no-results"
};
var _hoisted_57 = {
    key: 3,
    class: "selected-pharmacy-display",
    style: { "margin-top": "20px", "padding": "15px", "background-color": "#e8f5e9", "border": "2px solid #4caf50", "border-radius": "8px", "position": "relative" }
};
var _hoisted_58 = { style: { "display": "flex", "align-items": "center", "justify-content": "space-between", "margin-bottom": "10px" } };
var _hoisted_59 = { style: { "display": "flex", "align-items": "center" } };
var _hoisted_60 = { style: { "margin": "0", "color": "#2e7d32" } };
var _hoisted_61 = { style: { "margin-left": "30px" } };
var _hoisted_62 = { style: { "margin-bottom": "8px" } };
var _hoisted_63 = { style: { "color": "#333", "font-size": "1.1em" } };
var _hoisted_64 = {
    key: 0,
    style: { "margin-bottom": "8px" }
};
var _hoisted_65 = { style: { "color": "#333" } };
var _hoisted_66 = {
    key: 1,
    style: { "margin-bottom": "8px" }
};
var _hoisted_67 = { style: { "color": "#333" } };
var _hoisted_68 = {
    key: 2,
    style: { "margin-bottom": "8px" }
};
var _hoisted_69 = { style: { "color": "#333" } };
var _hoisted_70 = { style: { "margin-top": "10px", "display": "flex", "gap": "10px" } };
var _hoisted_71 = {
    key: 1,
    style: { "padding": "8px 16px", "background-color": "#e8f5e9", "color": "#2e7d32", "border": "1px solid #4caf50", "border-radius": "4px", "font-size": "0.9em", "display": "flex", "align-items": "center" }
};
var _hoisted_72 = {
    key: 4,
    class: "saved-pharmacies-section",
    style: { "margin-top": "20px" }
};
var _hoisted_73 = { style: { "display": "flex", "justify-content": "space-between", "align-items": "center", "margin-bottom": "15px" } };
var _hoisted_74 = {
    key: 0,
    style: { "color": "#2e7d32", "margin": "0", "display": "flex", "align-items": "center" }
};
var _hoisted_75 = {
    key: 1,
    style: { "color": "#757575", "margin": "0", "display": "flex", "align-items": "center" }
};
var _hoisted_76 = {
    class: "saved-pharmacies-list",
    style: { "display": "flex", "flex-direction": "column", "gap": "10px" }
};
var _hoisted_77 = {
    class: "saved-pharmacy-summary",
    style: { "padding": "12px", "background-color": "#f9f9f9", "display": "flex", "align-items": "center", "justify-content": "space-between" }
};
var _hoisted_78 = { style: { "flex": "1" } };
var _hoisted_79 = { style: { "font-weight": "600", "color": "#333", "margin-bottom": "4px" } };
var _hoisted_80 = { style: { "font-size": "0.85em", "color": "#666" } };
var _hoisted_81 = { key: 0 };
var _hoisted_82 = { key: 1 };
var _hoisted_83 = { key: 2 };
var _hoisted_84 = {
    key: 3,
    style: { "margin-left": "10px", "color": "#999", "font-size": "0.8em" }
};
var _hoisted_85 = { style: { "display": "flex", "gap": "8px" } };
var _hoisted_86 = ["onClick"];
var _hoisted_87 = ["onClick"];
var _hoisted_88 = {
    key: 0,
    class: "saved-pharmacy-details",
    style: { "padding": "15px", "background-color": "#fafafa", "border-top": "2px solid #ff9800" }
};
var _hoisted_89 = { style: { "display": "grid", "grid-template-columns": "repeat(auto-fit, minmax(200px, 1fr))", "gap": "12px", "margin-bottom": "15px" } };
var _hoisted_90 = ["onUpdate:modelValue"];
var _hoisted_91 = ["onUpdate:modelValue"];
var _hoisted_92 = ["onUpdate:modelValue"];
var _hoisted_93 = ["onUpdate:modelValue"];
var _hoisted_94 = ["onUpdate:modelValue"];
var _hoisted_95 = ["onUpdate:modelValue"];
var _hoisted_96 = { style: { "display": "flex", "gap": "10px", "justify-content": "flex-end", "border-top": "1px solid #eee", "padding-top": "12px" } };
var _hoisted_97 = ["onClick", "disabled"];
var _hoisted_98 = ["onClick"];
var _hoisted_99 = {
    key: 5,
    class: "retired-pharmacies-section",
    style: { "margin-top": "20px", "padding": "15px", "background-color": "#fafafa", "border": "1px solid #ddd", "border-radius": "8px" }
};
var _hoisted_100 = { style: { "color": "#757575", "margin-bottom": "15px", "display": "flex", "align-items": "center" } };
var _hoisted_101 = {
    class: "retired-pharmacies-list",
    style: { "display": "flex", "flex-direction": "column", "gap": "10px" }
};
var _hoisted_102 = { style: { "display": "flex", "justify-content": "space-between", "align-items": "center" } };
var _hoisted_103 = { style: { "flex": "1" } };
var _hoisted_104 = { style: { "font-weight": "600", "color": "#666", "margin-bottom": "4px", "text-decoration": "line-through" } };
var _hoisted_105 = { style: { "font-size": "0.85em", "color": "#999" } };
var _hoisted_106 = { key: 0 };
var _hoisted_107 = { key: 1 };
var _hoisted_108 = { key: 2 };
var _hoisted_109 = {
    key: 3,
    style: { "margin-left": "10px", "color": "#999" }
};
var _hoisted_110 = ["onClick"];
var _hoisted_111 = { class: "form-row" };
var _hoisted_112 = { class: "form-group" };
var _hoisted_113 = { class: "form-group" };
var _hoisted_114 = { class: "form-group" };
var _hoisted_115 = { class: "form-row" };
var _hoisted_116 = { class: "form-group" };
var _hoisted_117 = {
    key: 0,
    class: "error-message"
};
var _hoisted_118 = { class: "form-group" };
var _hoisted_119 = {
    key: 0,
    class: "error-message"
};
var _hoisted_120 = { class: "form-group" };
var vue_3 = require("vue");
var axios_1 = require("axios");
var apis_1 = require("@/constants/apis");
var PHARMACY_SEARCH_PAGE_SIZE = 8;
exports.default = (0, vue_1.defineComponent)({
    __name: 'MedicationPharmacyTabPanel',
    props: /*@__PURE__*/ (0, vue_1.mergeModels)({
        patientExternId: {},
        patientAccountNumber: {}
    }, {
        "modelValue": { required: true },
        "modelModifiers": {},
    }),
    emits: ["update:modelValue"],
    setup: function (__props) {
        var medForm = (0, vue_1.useModel)(__props, "modelValue");
        var props = __props;
        var patientExternId = props.patientExternId, patientAccountNumber = props.patientAccountNumber;
        function formatPhoneNumber(phone) {
            if (!phone)
                return '';
            var digitsOnly = phone.replace(/\D/g, '');
            if (digitsOnly.length === 0)
                return '';
            if (digitsOnly.length <= 3) {
                return "(".concat(digitsOnly);
            }
            else if (digitsOnly.length <= 6) {
                return "(".concat(digitsOnly.slice(0, 3), ")-").concat(digitsOnly.slice(3));
            }
            else if (digitsOnly.length <= 10) {
                return "(".concat(digitsOnly.slice(0, 3), ")-").concat(digitsOnly.slice(3, 6), "-").concat(digitsOnly.slice(6));
            }
            else {
                var last10 = digitsOnly.slice(-10);
                return "(".concat(last10.slice(0, 3), ")-").concat(last10.slice(3, 6), "-").concat(last10.slice(6));
            }
        }
        function validatePhoneNumber(phone) {
            if (!phone || phone.trim() === '')
                return '';
            var digitsOnly = phone.replace(/\D/g, '');
            if (digitsOnly.length === 10)
                return '';
            if (digitsOnly.length === 11 && digitsOnly.startsWith('1'))
                return '';
            return 'Phone number must be 10 digits or 11 digits starting with 1';
        }
        function handlePhoneInput(phoneValue, errorRef, fieldOrCb, callback) {
            var formatted = formatPhoneNumber(phoneValue);
            if (typeof fieldOrCb === 'function') {
                pharmacySearch.value.telephone = formatted;
                errorRef.value = validatePhoneNumber(formatted);
                fieldOrCb();
                return;
            }
            ;
            medForm.value[fieldOrCb] = formatted;
            if (errorRef.value) {
                errorRef.value = validatePhoneNumber(formatted);
            }
            if (callback)
                callback();
        }
        var loadedpatientNPI = (0, vue_3.ref)('');
        var pharmacyOfficeError = (0, vue_3.ref)('');
        var pharmacyCellError = (0, vue_3.ref)('');
        var pharmacySearchTelephoneError = (0, vue_3.ref)('');
        var pharmacySearch = (0, vue_3.ref)({
            name: '',
            telephone: '',
            city: '',
            state: '',
            postal_code: '',
        });
        // --- more refs ---
        var newPharmacy = (0, vue_3.ref)([]);
        var pastpatPharmacy = (0, vue_3.ref)([]);
        // Computed property to filter pharmacies by unique NPI, keeping the most recent assigned_date, sorted by most recent first
        var filteredPastPatPharmacy = (0, vue_3.computed)(function () {
            if (!pastpatPharmacy.value || pastpatPharmacy.value.length === 0) {
                return [];
            }
            // Create a map to store the most recent pharmacy for each NPI
            var pharmacyMap = new Map();
            pastpatPharmacy.value.forEach(function (pharm) {
                var npi = pharm.npinumber || '';
                // Skip if NPI is empty
                if (!npi) {
                    return;
                }
                // If this NPI hasn't been seen, or if this one has a more recent assigned_date
                if (!pharmacyMap.has(npi)) {
                    pharmacyMap.set(npi, pharm);
                }
                else {
                    var existing = pharmacyMap.get(npi);
                    var existingDate = (existing === null || existing === void 0 ? void 0 : existing.assigned_date) ? new Date(existing.assigned_date) : null;
                    var currentDate = pharm.assigned_date ? new Date(pharm.assigned_date) : null;
                    // If current has a date and existing doesn't, or current date is more recent
                    if (currentDate && (!existingDate || currentDate > existingDate)) {
                        pharmacyMap.set(npi, pharm);
                    }
                }
            });
            // Convert map values back to array and sort by assigned_date (most recent first)
            var pharmacies = Array.from(pharmacyMap.values());
            return pharmacies.sort(function (a, b) {
                var dateA = a.assigned_date ? new Date(a.assigned_date).getTime() : 0;
                var dateB = b.assigned_date ? new Date(b.assigned_date).getTime() : 0;
                return dateB - dateA; // Most recent first
            });
        });
        // Computed property for visible pharmacies (first 2)
        var visiblePastPatPharmacy = (0, vue_3.computed)(function () {
            return filteredPastPatPharmacy.value.slice(0, 2);
        });
        // Computed property for hidden pharmacies (rest after first 2)
        var hiddenPastPatPharmacy = (0, vue_3.computed)(function () {
            return filteredPastPatPharmacy.value.slice(2);
        });
        // State for showing/hiding more pharmacies
        var showMorePharmacies = (0, vue_3.ref)(false);
        var newProvloaded = (0, vue_3.ref)(false);
        var newpastPatPharcy = (0, vue_3.ref)(false);
        var newPharmloaded = (0, vue_3.ref)(false);
        var showIvform = (0, vue_3.ref)(false);
        var searchTerm = (0, vue_3.ref)('');
        var newDiagloaded = (0, vue_3.ref)(false);
        var newDiagcodes = (0, vue_3.ref)([]);
        var selectedTaxonomy = (0, vue_3.ref)('');
        var pharmacySearchResults = (0, vue_3.ref)([]);
        var pharmacySearchHint = (0, vue_3.ref)('');
        var pharmacySearchTimeout = null;
        /** NPI/pharmacy lookup often returns many rows — show a page at a time (same UX as AddMedicationForm). */
        var pharmacySearchVisibleCount = (0, vue_3.ref)(PHARMACY_SEARCH_PAGE_SIZE);
        var displayedPharmacySearchResults = (0, vue_3.computed)(function () {
            var all = pharmacySearchResults.value;
            var n = Math.min(pharmacySearchVisibleCount.value, all.length);
            return all.slice(0, n);
        });
        var pharmacySearchHiddenCount = (0, vue_3.computed)(function () {
            return Math.max(0, pharmacySearchResults.value.length - displayedPharmacySearchResults.value.length);
        });
        var expandedPharmacyIndex = (0, vue_3.ref)(null); // Track which pharmacy accordion is expanded (search results)
        var editingPharmacyFields = (0, vue_3.ref)({}); // Store edited fields for each pharmacy (search results)
        function resetPharmacySearchPagination() {
            pharmacySearchVisibleCount.value = PHARMACY_SEARCH_PAGE_SIZE;
        }
        function showMorePharmacySearchResults() {
            var len = pharmacySearchResults.value.length;
            pharmacySearchVisibleCount.value = Math.min(len, pharmacySearchVisibleCount.value + PHARMACY_SEARCH_PAGE_SIZE);
        }
        function showAllPharmacySearchResults() {
            pharmacySearchVisibleCount.value = pharmacySearchResults.value.length;
        }
        function collapsePharmacySearchResults() {
            pharmacySearchVisibleCount.value = Math.min(PHARMACY_SEARCH_PAGE_SIZE, pharmacySearchResults.value.length);
            if (expandedPharmacyIndex.value !== null &&
                expandedPharmacyIndex.value >= pharmacySearchVisibleCount.value) {
                expandedPharmacyIndex.value = null;
            }
        }
        function onPharmacySummaryEnter(ev) {
            var el = ev.currentTarget;
            if (el)
                el.style.backgroundColor = '#f0f0f0';
        }
        function onPharmacySummaryLeave(ev) {
            var el = ev.currentTarget;
            if (el)
                el.style.backgroundColor = '#f9f9f9';
        }
        var expandedSavedPharmacyIndex = (0, vue_3.ref)(null); // Track which saved pharmacy is expanded for editing
        var editingSavedPharmacyFields = (0, vue_3.ref)({}); // Store edited fields for each saved pharmacy
        // Saved pharmacies list
        var savedPharmacies = (0, vue_3.ref)([]);
        var retiredPharmacies = (0, vue_3.ref)([]); // History of retired pharmacies
        var editingPharmacyIndex = (0, vue_3.ref)(null);
        var isPharmacySelected = (0, vue_3.ref)(false);
        var showRetiredPharmacies = (0, vue_3.ref)(false); // Toggle to show/hide retired pharmacies
        //KW Account verifiction var 3/5/2026
        var isAccountVerified = (0, vue_3.ref)(false);
        var showAccountStatTag = (0, vue_3.ref)(false);
        // Computed property to check if search can be performed
        // Search can be performed if:
        // - Name is provided, OR
        // - Telephone number is provided, OR
        // - At least one location (city, state, or ZIP) is provided
        var canSearchPharmacy = (0, vue_3.computed)(function () {
            var hasName = pharmacySearch.value.name.trim() !== '';
            var hasTelephone = pharmacySearch.value.telephone.trim() !== '';
            var hasLocation = pharmacySearch.value.city.trim() !== '' ||
                pharmacySearch.value.state.trim() !== '' ||
                pharmacySearch.value.postal_code.trim() !== '';
            return hasName || hasTelephone || hasLocation;
        });
        // Computed property to check if the currently selected pharmacy is already saved (active only)
        var isPharmacyAlreadySaved = (0, vue_3.computed)(function () {
            if (!medForm.value.pharmacyNpi || medForm.value.pharmacyNpi.trim() === '') {
                return false;
            }
            // Check if a pharmacy with the same NPI is already in saved list (active only)
            return savedPharmacies.value.some(function (pharm) {
                return pharm.npi === medForm.value.pharmacyNpi &&
                    pharm.npi !== '' &&
                    pharm.npi !== null &&
                    pharm.status === 'active';
            });
        });
        // Computed property to get only active pharmacies
        var activePharmacies = (0, vue_3.computed)(function () {
            return savedPharmacies.value.filter(function (pharm) { return pharm.status === 'active'; });
        });
        // Computed property to check if saved pharmacy edits can be saved (at least one field filled)
        function canSaveSavedPharmacyEdits(index) {
            var edits = editingSavedPharmacyFields.value[index];
            if (!edits)
                return false;
            // Check if at least one field has a value
            return !!((edits.name && edits.name.trim() !== '') ||
                (edits.npi && edits.npi.trim() !== '') ||
                (edits.dea && edits.dea.trim() !== '') ||
                (edits.address && edits.address.trim() !== '') ||
                (edits.phone && edits.phone.trim() !== '') ||
                (edits.cell && edits.cell.trim() !== ''));
        }
        function selectpastPharm() {
            for (var i = 0; i < filteredPastPatPharmacy.value.length; i++) {
                if (filteredPastPatPharmacy.value[i].npinumber == loadedpatientNPI.value) {
                    medForm.value.pharmacyName = filteredPastPatPharmacy.value[i].pharmacyname;
                    medForm.value.pharmacyNpi = filteredPastPatPharmacy.value[i].npinumber;
                    medForm.value.pharmacyAddress = filteredPastPatPharmacy.value[i].pharmaddress;
                    medForm.value.pharmacyOffice = filteredPastPatPharmacy.value[i].pharmtel || '';
                    medForm.value.pharmacyCell = filteredPastPatPharmacy.value[i].pharmcell || '';
                    medForm.value.pharmacyEmail = filteredPastPatPharmacy.value[i].pharmemail || '';
                    medForm.value.pharmacyDea = filteredPastPatPharmacy.value[i].pharmdea || '';
                }
            }
        }
        /*Handle using a past pharmacy from the button list*/
        function usePastPharmacy(index) {
            var pharm = filteredPastPatPharmacy.value[index];
            if (pharm) {
                medForm.value.pharmacyName = pharm.pharmacyname || '';
                medForm.value.pharmacyNpi = pharm.npinumber || '';
                medForm.value.pharmacyAddress = pharm.pharmaddress || '';
                medForm.value.pharmacyOffice = pharm.pharmtel || '';
                medForm.value.pharmacyCell = pharm.pharmcell || '';
                medForm.value.pharmacyEmail = pharm.pharmemail || '';
                medForm.value.pharmacyDea = pharm.pharmdea || '';
            }
        }
        function selectPharm(index) {
            // Check if using new pharmacy search results
            if (pharmacySearchResults.value && pharmacySearchResults.value.length > 0 && pharmacySearchResults.value[index]) {
                var pharm = pharmacySearchResults.value[index];
                medForm.value.pharmacyName = pharm.name;
                medForm.value.pharmacyNpi = pharm.npi;
                // Format address
                var addr = pharm.address;
                if (addr) {
                    var addrParts = [];
                    if (addr.line1)
                        addrParts.push(addr.line1);
                    if (addr.line2)
                        addrParts.push(addr.line2);
                    if (addr.city)
                        addrParts.push(addr.city);
                    if (addr.state)
                        addrParts.push(addr.state);
                    if (addr.postalCode)
                        addrParts.push(addr.postalCode);
                    medForm.value.pharmacyAddress = addrParts.join(', ');
                }
                if (pharm.telephone) {
                    medForm.value.pharmacyOffice = pharm.telephone;
                    medForm.value.pharmacyCell = pharm.telephone;
                }
                newPharmloaded.value = false;
                pharmacySearchResults.value = [];
                resetPharmacySearchPagination();
                expandedPharmacyIndex.value = null;
                pharmacySearch.value = { name: '', telephone: '', city: '', state: '', postal_code: '' };
                isPharmacySelected.value = true; // Mark as selected to hide Add button
            }
            else if (newPharmacy.value && newPharmacy.value.length > 0 && newPharmacy.value[index]) {
                // Fallback to old format for backward compatibility
                medForm.value.pharmacyName = newPharmacy.value[index].name;
                medForm.value.pharmacyNpi = newPharmacy.value[index].npinumber;
                if (newPharmacy.value[index].addresses && newPharmacy.value[index].addresses[index]) {
                    medForm.value.pharmacyAddress = newPharmacy.value[index].addresses[index].address;
                    medForm.value.pharmacyOffice = newPharmacy.value[index].addresses[index].tel;
                    medForm.value.pharmacyCell = newPharmacy.value[index].addresses[index].tel;
                }
                newPharmloaded.value = false;
                isPharmacySelected.value = true; // Mark as selected to hide Add button
            }
        }
        // Function to save selected pharmacy
        function saveSelectedPharmacy() {
            // Validate that required fields are filled
            if (!medForm.value.pharmacyName || medForm.value.pharmacyName.trim() === '') {
                alert('Please select a pharmacy first');
                return;
            }
            // Ensure all pharmacy fields are populated from formData
            // If any field is missing, use empty string as default
            var pharmacyData = {
                name: medForm.value.pharmacyName || '',
                npi: medForm.value.pharmacyNpi || '',
                address: medForm.value.pharmacyAddress || '',
                phone: medForm.value.pharmacyOffice || '',
                cell: medForm.value.pharmacyCell || '',
                dea: medForm.value.pharmacyDea || '',
                status: 'active', // Mark as active
                dateAdded: new Date().toISOString(), // Track when added
                dateRetired: null // Will be set when retired
            };
            // After saving, ensure all form fields are still populated with the saved pharmacy data
            // This ensures the form fields match what was saved
            medForm.value.pharmacyName = pharmacyData.name;
            medForm.value.pharmacyNpi = pharmacyData.npi;
            medForm.value.pharmacyAddress = pharmacyData.address;
            medForm.value.pharmacyOffice = pharmacyData.phone;
            medForm.value.pharmacyCell = pharmacyData.cell;
            medForm.value.pharmacyDea = pharmacyData.dea;
            // Check if we're replacing an existing pharmacy
            if (editingPharmacyIndex.value !== null && editingPharmacyIndex.value >= 0) {
                // Replace existing pharmacy
                savedPharmacies.value[editingPharmacyIndex.value] = pharmacyData;
                pharmacySearchHint.value = 'Pharmacy replaced successfully! ?';
                editingPharmacyIndex.value = null;
            }
            else {
                // Check if pharmacy already exists to prevent duplicates (only check active pharmacies)
                var exists = savedPharmacies.value.some(function (p) {
                    return p.npi === pharmacyData.npi &&
                        p.npi !== '' &&
                        p.npi !== null &&
                        p.status === 'active';
                });
                if (exists) {
                    alert('This pharmacy is already in your saved list!');
                    return;
                }
                // Add new pharmacy to the list
                savedPharmacies.value.push(pharmacyData);
                pharmacySearchHint.value = 'Pharmacy added successfully! ?';
            }
            // Don't clear the selection after saving - keep all fields filled
            // The user can manually clear if needed, or select another pharmacy
            // This ensures all fields remain populated after saving
            // clearSelectedPharmacy(); // Commented out to keep fields filled
            // Show confirmation
            setTimeout(function () {
                pharmacySearchHint.value = '';
            }, 3000);
            console.log('Pharmacy saved:', pharmacyData);
            console.log('Total saved pharmacies:', savedPharmacies.value.length);
        }
        // Function to select a saved pharmacy (use it in the form)
        function selectSavedPharmacy(index) {
            var pharm = savedPharmacies.value[index];
            if (pharm) {
                medForm.value.pharmacyName = pharm.name;
                medForm.value.pharmacyNpi = pharm.npi || '';
                medForm.value.pharmacyAddress = pharm.address || '';
                medForm.value.pharmacyOffice = pharm.phone || '';
                medForm.value.pharmacyCell = pharm.cell || '';
                medForm.value.pharmacyDea = pharm.dea || '';
                isPharmacySelected.value = true; // Mark as selected to hide Add button
                editingPharmacyIndex.value = null; // Not in edit mode when using
                pharmacySearchHint.value = 'Pharmacy loaded into form! ?';
                setTimeout(function () {
                    pharmacySearchHint.value = '';
                }, 2000);
            }
        }
        // Function to edit/replace a saved pharmacy
        function editSavedPharmacy(index) {
            var pharm = activePharmacies.value[index];
            if (pharm) {
                // Find the actual index in savedPharmacies array
                var actualIndex = savedPharmacies.value.findIndex(function (p) {
                    return p.npi === pharm.npi && p.status === 'active';
                });
                // Load pharmacy into form for editing
                medForm.value.pharmacyName = pharm.name;
                medForm.value.pharmacyNpi = pharm.npi || '';
                medForm.value.pharmacyAddress = pharm.address || '';
                medForm.value.pharmacyOffice = pharm.phone || '';
                medForm.value.pharmacyCell = pharm.cell || '';
                medForm.value.pharmacyDea = pharm.dea || '';
                // Set editing mode
                editingPharmacyIndex.value = actualIndex !== -1 ? actualIndex : null;
                isPharmacySelected.value = true; // Show selected pharmacy display
                // Switch to pharmacy info tab to show the pharmacy fields
                activeTab.value = 'pharmacyInfo';
                // Scroll to selected pharmacy display
                setTimeout(function () {
                    var selectedPharmacyEl = document.querySelector('.selected-pharmacy-display');
                    if (selectedPharmacyEl) {
                        selectedPharmacyEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                    }
                }, 100);
                pharmacySearchHint.value = 'Pharmacy loaded for editing. Make changes and click Save at the bottom of the page.';
            }
        }
        // Function to retire a pharmacy (move to history instead of deleting)
        function retirePharmacy(index) {
            var pharm = activePharmacies.value[index];
            if (pharm && confirm("Are you sure you want to retire \"".concat(pharm.name, "\"? It will be moved to history."))) {
                // Find the actual index in savedPharmacies array
                var actualIndex = savedPharmacies.value.findIndex(function (p) {
                    return p.npi === pharm.npi && p.status === 'active';
                });
                if (actualIndex !== -1) {
                    // Mark as retired and set retirement date
                    savedPharmacies.value[actualIndex].status = 'retired';
                    savedPharmacies.value[actualIndex].dateRetired = new Date().toISOString();
                    // Move to retired list
                    retiredPharmacies.value.push(__assign({}, savedPharmacies.value[actualIndex]));
                    pharmacySearchHint.value = 'Pharmacy retired and moved to history';
                    setTimeout(function () {
                        pharmacySearchHint.value = '';
                    }, 2000);
                }
            }
        }
        // Function to restore a retired pharmacy
        function restorePharmacy(index) {
            var pharm = retiredPharmacies.value[index];
            if (pharm && confirm("Restore \"".concat(pharm.name, "\" to active pharmacies?"))) {
                // Update status back to active
                pharm.status = 'active';
                pharm.dateRetired = null;
                // Remove from retired list
                retiredPharmacies.value.splice(index, 1);
                // Add back to saved pharmacies (or update if it exists)
                var existingIndex = savedPharmacies.value.findIndex(function (p) { return p.npi === pharm.npi; });
                if (existingIndex !== -1) {
                    savedPharmacies.value[existingIndex] = pharm;
                }
                else {
                    savedPharmacies.value.push(pharm);
                }
                pharmacySearchHint.value = 'Pharmacy restored to active list';
                setTimeout(function () {
                    pharmacySearchHint.value = '';
                }, 2000);
            }
        }
        // Helper function to format date
        function formatDate(dateString) {
            if (!dateString)
                return '';
            try {
                var date = new Date(dateString);
                return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
            }
            catch (e) {
                return dateString;
            }
        }
        // Function to clear selected pharmacy
        function clearSelectedPharmacy() {
            medForm.value.pharmacyName = '';
            medForm.value.pharmacyNpi = '';
            medForm.value.pharmacyAddress = '';
            medForm.value.pharmacyOffice = '';
            medForm.value.pharmacyCell = '';
            pharmacySearchHint.value = '';
            editingPharmacyIndex.value = null; // Clear editing mode
            isPharmacySelected.value = false; // Reset selection flag
        }
        function onPharmacyNameInput() {
            console.log('Pharmacy name input triggered:', pharmacySearch.value.name);
            var hasName = pharmacySearch.value.name.trim() !== '';
            var hasTelephone = pharmacySearch.value.telephone.trim() !== '';
            var hasLocation = pharmacySearch.value.city.trim() !== '' ||
                pharmacySearch.value.state.trim() !== '' ||
                pharmacySearch.value.postal_code.trim() !== '';
            console.log('Has name:', hasName, 'Has telephone:', hasTelephone, 'Has location:', hasLocation);
            if (!hasName && !hasTelephone && !hasLocation) {
                pharmacySearchHint.value = 'Please enter a pharmacy name, telephone number, or at least one location (city, state, or ZIP code)';
                console.log('Showing hint: name, telephone, or location required');
            }
            else if ((hasName || hasTelephone) && !hasLocation) {
                pharmacySearchHint.value = 'Optional: Add a city, state, or ZIP code to narrow results';
                console.log('Showing hint: location optional');
                // Can search with just name or telephone, but trigger search
                triggerDebouncedPharmacySearch();
            }
            else {
                pharmacySearchHint.value = 'Ready to search...';
                console.log('Triggering debounced search');
                // Trigger debounced search if requirements are met
                triggerDebouncedPharmacySearch();
            }
        }
        // Debounced pharmacy search - automatically searches after user stops typing
        function triggerDebouncedPharmacySearch() {
            console.log('triggerDebouncedPharmacySearch called');
            var hasName = pharmacySearch.value.name.trim() !== '';
            var hasLocation = pharmacySearch.value.city.trim() !== '' ||
                pharmacySearch.value.state.trim() !== '' ||
                pharmacySearch.value.postal_code.trim() !== '';
            console.log('Has name:', hasName, 'Has location:', hasLocation);
            console.log('canSearchPharmacy:', canSearchPharmacy.value);
            // Clear existing timeout
            if (pharmacySearchTimeout) {
                clearTimeout(pharmacySearchTimeout);
                pharmacySearchTimeout = null;
            }
            // Update hint message based on current state
            var hasTelephone = pharmacySearch.value.telephone.trim() !== '';
            if (!hasName && !hasTelephone && !hasLocation) {
                pharmacySearchHint.value = 'Please enter a pharmacy name, telephone number, or at least one location (city, state, or ZIP code)';
                console.log('Cannot search - no name, telephone, or location');
                return;
            }
            // Don't search if name is only 1 character (wait for more characters)
            if (hasName && pharmacySearch.value.name.trim().length === 1) {
                pharmacySearchHint.value = '';
                return;
            }
            // Only search if we have name, telephone, OR at least one location
            if (canSearchPharmacy.value) {
                console.log('Setting timeout for pharmacy search (800ms)');
                if ((hasName || hasTelephone) && hasLocation) {
                    pharmacySearchHint.value = 'Searching in a moment...';
                }
                else if (hasLocation && !hasName && !hasTelephone) {
                    pharmacySearchHint.value = 'Searching all pharmacies in this area...';
                }
                else if (hasTelephone) {
                    pharmacySearchHint.value = 'Searching by telephone number...';
                }
                else {
                    pharmacySearchHint.value = 'Searching...';
                }
                pharmacySearchTimeout = setTimeout(function () {
                    console.log('Timeout fired, calling searchPharmacy');
                    searchPharmacy();
                }, 800); // Wait 800ms after user stops typing
            }
            else {
                console.log('Cannot search - requirements not met');
                if ((hasName || hasTelephone) && !hasLocation) {
                    pharmacySearchHint.value = 'Optional: Add a city, state, or ZIP code to narrow results';
                }
            }
        }
        // Wrapper function to handle pharmacy search with better error handling
        function handlePharmacySearch() {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!canSearchPharmacy.value) {
                                pharmacySearchHint.value = 'Please enter a pharmacy name, telephone number, or at least one location (city, state, or ZIP code)';
                                return [2 /*return*/];
                            }
                            pharmacySearchHint.value = '';
                            return [4 /*yield*/, searchPharmacy()];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        }
        // New pharmacy search function using the new API
        function searchPharmacy() {
            return __awaiter(this, void 0, void 0, function () {
                var hasName, hasTelephone, hasLocation, params, apiUrl, response, errorMsg, error_1, errorMsg;
                var _a, _b, _c, _d, _e, _f;
                return __generator(this, function (_g) {
                    switch (_g.label) {
                        case 0:
                            hasName = pharmacySearch.value.name && pharmacySearch.value.name.trim() !== '';
                            hasTelephone = pharmacySearch.value.telephone && pharmacySearch.value.telephone.trim() !== '';
                            hasLocation = (pharmacySearch.value.city && pharmacySearch.value.city.trim() !== '') ||
                                (pharmacySearch.value.state && pharmacySearch.value.state.trim() !== '') ||
                                (pharmacySearch.value.postal_code && pharmacySearch.value.postal_code.trim() !== '');
                            if (!hasName && !hasTelephone && !hasLocation) {
                                pharmacySearchHint.value = 'Please enter a pharmacy name, telephone number, or at least one location (city, state, or ZIP code)';
                                return [2 /*return*/];
                            }
                            // Don't search if name is only 1 character (API requires at least 2 characters)
                            // Allow the user to continue typing without triggering a search
                            if (hasName && pharmacySearch.value.name.trim().length === 1) {
                                pharmacySearchHint.value = '';
                                return [2 /*return*/];
                            }
                            pharmacySearchHint.value = 'Searching...';
                            _g.label = 1;
                        case 1:
                            _g.trys.push([1, 3, , 4]);
                            params = new URLSearchParams();
                            if (pharmacySearch.value.name && pharmacySearch.value.name.trim()) {
                                params.append('name', pharmacySearch.value.name.trim());
                            }
                            if (pharmacySearch.value.telephone && pharmacySearch.value.telephone.trim()) {
                                params.append('telephone', pharmacySearch.value.telephone.trim());
                            }
                            if (pharmacySearch.value.city && pharmacySearch.value.city.trim()) {
                                params.append('city', pharmacySearch.value.city.trim());
                            }
                            if (pharmacySearch.value.state && pharmacySearch.value.state.trim()) {
                                params.append('state', pharmacySearch.value.state.trim().toUpperCase());
                            }
                            if (pharmacySearch.value.postal_code && pharmacySearch.value.postal_code.trim()) {
                                params.append('postal_code', pharmacySearch.value.postal_code.trim());
                            }
                            apiUrl = apis_1.CURR_API + '/pharmacies.php?' + params.toString();
                            console.log('Searching pharmacies with URL:', apiUrl);
                            console.log('Search params:', {
                                name: pharmacySearch.value.name,
                                telephone: pharmacySearch.value.telephone,
                                city: pharmacySearch.value.city,
                                state: pharmacySearch.value.state,
                                postal_code: pharmacySearch.value.postal_code
                            });
                            return [4 /*yield*/, axios_1.default.get(apiUrl)];
                        case 2:
                            response = _g.sent();
                            console.log('Pharmacy search response status:', response.status);
                            console.log('Pharmacy search response data:', response.data);
                            console.log('Response data type:', typeof response.data);
                            console.log('Has results?', !!((_a = response.data) === null || _a === void 0 ? void 0 : _a.results));
                            console.log('Results count:', (_b = response.data) === null || _b === void 0 ? void 0 : _b.count);
                            console.log('Results array length:', (_d = (_c = response.data) === null || _c === void 0 ? void 0 : _c.results) === null || _d === void 0 ? void 0 : _d.length);
                            if (response.data) {
                                if (response.data.error) {
                                    errorMsg = response.data.error;
                                    if (errorMsg.toLowerCase().includes('character') || errorMsg.toLowerCase().includes('minimum')) {
                                        pharmacySearchHint.value = '';
                                        pharmacySearchResults.value = [];
                                        newPharmloaded.value = false;
                                        resetPharmacySearchPagination();
                                        expandedPharmacyIndex.value = null;
                                    }
                                    else {
                                        pharmacySearchHint.value = errorMsg;
                                        pharmacySearchResults.value = [];
                                        newPharmloaded.value = true;
                                        resetPharmacySearchPagination();
                                        expandedPharmacyIndex.value = null;
                                    }
                                    console.error('API returned error:', errorMsg);
                                }
                                else if (Array.isArray(response.data.results)) {
                                    pharmacySearchResults.value = response.data.results;
                                    newPharmloaded.value = true;
                                    newpastPatPharcy.value = false;
                                    resetPharmacySearchPagination();
                                    expandedPharmacyIndex.value = null;
                                    if (response.data.results.length === 0) {
                                        pharmacySearchHint.value = 'No pharmacies found. Please try different search criteria.';
                                        console.log('No results in response');
                                    }
                                    else {
                                        pharmacySearchHint.value = "Found ".concat(response.data.results.length, " pharmacy(ies)");
                                        console.log('Successfully loaded', response.data.results.length, 'pharmacies');
                                    }
                                }
                                else if (response.data.results) {
                                    // Handle case where results might not be an array
                                    pharmacySearchResults.value = Array.isArray(response.data.results) ? response.data.results : [];
                                    newPharmloaded.value = true;
                                    newpastPatPharcy.value = false;
                                    resetPharmacySearchPagination();
                                    expandedPharmacyIndex.value = null;
                                    pharmacySearchHint.value = "Found ".concat(pharmacySearchResults.value.length, " pharmacy(ies)");
                                }
                                else {
                                    pharmacySearchResults.value = [];
                                    newPharmloaded.value = true;
                                    pharmacySearchHint.value = 'No results found - response format unexpected';
                                    resetPharmacySearchPagination();
                                    expandedPharmacyIndex.value = null;
                                    console.error('Unexpected response format:', response.data);
                                }
                            }
                            else {
                                pharmacySearchResults.value = [];
                                newPharmloaded.value = true;
                                pharmacySearchHint.value = 'Invalid response from server';
                                resetPharmacySearchPagination();
                                expandedPharmacyIndex.value = null;
                                console.error('No data in response');
                            }
                            return [3 /*break*/, 4];
                        case 3:
                            error_1 = _g.sent();
                            console.error('Error searching pharmacies:', error_1);
                            errorMsg = ((_f = (_e = error_1.response) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.error) || error_1.message || 'Error searching for pharmacies. Please try again.';
                            // Handle errors gracefully without showing alerts
                            // If error is about minimum character length, just clear the hint
                            if (errorMsg.toLowerCase().includes('character') || errorMsg.toLowerCase().includes('minimum')) {
                                pharmacySearchHint.value = '';
                                pharmacySearchResults.value = [];
                                newPharmloaded.value = false;
                                resetPharmacySearchPagination();
                                expandedPharmacyIndex.value = null;
                            }
                            else {
                                pharmacySearchHint.value = errorMsg;
                                pharmacySearchResults.value = [];
                                newPharmloaded.value = false;
                                resetPharmacySearchPagination();
                                expandedPharmacyIndex.value = null;
                            }
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        }
        // Helper function to format pharmacy address
        function formatPharmacyAddress(address) {
            if (!address)
                return '';
            var parts = [];
            if (address.line1)
                parts.push(address.line1);
            if (address.line2)
                parts.push(address.line2);
            if (address.city)
                parts.push(address.city);
            if (address.state)
                parts.push(address.state);
            if (address.postalCode)
                parts.push(address.postalCode);
            return parts.join(', ');
        }
        // Toggle pharmacy accordion
        function togglePharmacyAccordion(index) {
            var _a, _b, _c, _d, _e;
            if (expandedPharmacyIndex.value === index) {
                expandedPharmacyIndex.value = null;
            }
            else {
                expandedPharmacyIndex.value = index;
                // Initialize editing fields for this pharmacy if not already done
                if (!editingPharmacyFields.value[index]) {
                    var pharm = pharmacySearchResults.value[index];
                    editingPharmacyFields.value[index] = {
                        name: pharm.name || '',
                        npi: pharm.npi || '',
                        addressLine1: ((_a = pharm.address) === null || _a === void 0 ? void 0 : _a.line1) || '',
                        addressLine2: ((_b = pharm.address) === null || _b === void 0 ? void 0 : _b.line2) || '',
                        city: ((_c = pharm.address) === null || _c === void 0 ? void 0 : _c.city) || '',
                        state: ((_d = pharm.address) === null || _d === void 0 ? void 0 : _d.state) || '',
                        postalCode: ((_e = pharm.address) === null || _e === void 0 ? void 0 : _e.postalCode) || '',
                        telephone: pharm.telephone || ''
                    };
                }
            }
        }
        // Note: updatePharmacyField is no longer needed - v-model handles updates automatically
        // Apply edits to the pharmacy result
        function applyPharmacyEdits(index) {
            var edits = editingPharmacyFields.value[index];
            if (!edits)
                return;
            var pharm = pharmacySearchResults.value[index];
            // Update the pharmacy result with edited values
            if (edits.name !== undefined)
                pharm.name = edits.name;
            if (edits.npi !== undefined)
                pharm.npi = edits.npi;
            if (edits.telephone !== undefined)
                pharm.telephone = edits.telephone;
            // Update address
            if (!pharm.address) {
                pharm.address = {};
            }
            if (edits.addressLine1 !== undefined)
                pharm.address.line1 = edits.addressLine1;
            if (edits.addressLine2 !== undefined)
                pharm.address.line2 = edits.addressLine2;
            if (edits.city !== undefined)
                pharm.address.city = edits.city;
            if (edits.state !== undefined)
                pharm.address.state = edits.state;
            if (edits.postalCode !== undefined)
                pharm.address.postalCode = edits.postalCode;
            pharmacySearchHint.value = 'Pharmacy details updated! ?';
            setTimeout(function () {
                pharmacySearchHint.value = '';
            }, 2000);
        }
        // Select pharmacy with applied edits
        function selectPharmWithEdits(index) {
            // Apply edits first
            applyPharmacyEdits(index);
            // Then select the pharmacy
            selectPharm(index);
            // Close accordion
            expandedPharmacyIndex.value = null;
        }
        // Reset pharmacy edits to original values
        function resetPharmacyEdits(index) {
            var _a, _b, _c, _d, _e;
            var pharm = pharmacySearchResults.value[index];
            editingPharmacyFields.value[index] = {
                name: pharm.name || '',
                npi: pharm.npi || '',
                addressLine1: ((_a = pharm.address) === null || _a === void 0 ? void 0 : _a.line1) || '',
                addressLine2: ((_b = pharm.address) === null || _b === void 0 ? void 0 : _b.line2) || '',
                city: ((_c = pharm.address) === null || _c === void 0 ? void 0 : _c.city) || '',
                state: ((_d = pharm.address) === null || _d === void 0 ? void 0 : _d.state) || '',
                postalCode: ((_e = pharm.address) === null || _e === void 0 ? void 0 : _e.postalCode) || '',
                telephone: pharm.telephone || ''
            };
        }
        // Toggle saved pharmacy edit mode
        function toggleSavedPharmacyEdit(index) {
            if (expandedSavedPharmacyIndex.value === index) {
                expandedSavedPharmacyIndex.value = null;
            }
            else {
                expandedSavedPharmacyIndex.value = index;
                // Initialize editing fields for this saved pharmacy
                var pharm_1 = activePharmacies.value[index];
                // Find the actual index in savedPharmacies array
                var actualIndex = savedPharmacies.value.findIndex(function (p) {
                    return p.npi === pharm_1.npi && p.status === 'active';
                });
                var actualPharm = savedPharmacies.value[actualIndex];
                editingSavedPharmacyFields.value[index] = {
                    name: actualPharm.name || '',
                    npi: actualPharm.npi || '',
                    dea: actualPharm.dea || '',
                    address: actualPharm.address || '',
                    phone: actualPharm.phone || '',
                    cell: actualPharm.cell || ''
                };
            }
        }
        // Save edits to saved pharmacy
        function saveSavedPharmacyEdits(index) {
            var edits = editingSavedPharmacyFields.value[index];
            if (!edits)
                return;
            // Find the actual index in savedPharmacies array
            var pharm = activePharmacies.value[index];
            var actualIndex = savedPharmacies.value.findIndex(function (p) {
                return p.npi === pharm.npi && p.status === 'active';
            });
            if (actualIndex !== -1) {
                // Update the saved pharmacy with edited values
                savedPharmacies.value[actualIndex].name = edits.name || '';
                savedPharmacies.value[actualIndex].npi = edits.npi || '';
                savedPharmacies.value[actualIndex].dea = edits.dea || '';
                savedPharmacies.value[actualIndex].address = edits.address || '';
                savedPharmacies.value[actualIndex].phone = edits.phone || '';
                savedPharmacies.value[actualIndex].cell = edits.cell || '';
                pharmacySearchHint.value = 'Pharmacy details saved successfully! ?';
                // Close the edit section and clear editing fields
                expandedSavedPharmacyIndex.value = null;
                delete editingSavedPharmacyFields.value[index];
                setTimeout(function () {
                    pharmacySearchHint.value = '';
                }, 2000);
            }
        }
        // Cancel saved pharmacy edit
        function cancelSavedPharmacyEdit(index) {
            expandedSavedPharmacyIndex.value = null;
            // Clear editing fields
            delete editingSavedPharmacyFields.value[index];
        }
        // Old function kept for backward compatibility (deprecated)
        function showPharmacyResult() {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!medForm.value.pharmacyName) return [3 /*break*/, 2];
                            pharmacySearch.value.name = medForm.value.pharmacyName;
                            return [4 /*yield*/, searchPharmacy()];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        }
        /*Patient assigned Pharmacy Lookup Axios Call*/
        function loadPatientPharmacy() {
            return __awaiter(this, void 0, void 0, function () {
                var content;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            content = {
                                MedicationAdmin: {
                                    API_Meth: "GetAssignedPatPharmacy",
                                    patientid: patientExternId,
                                    accountnumber: patientAccountNumber
                                }
                            };
                            return [4 /*yield*/, axios_1.default
                                    .post(apis_1.CURR_API + '/tswebhook.php', content, {
                                    headers: { "Content-Type": "application/json;" },
                                })
                                    .then(function (res) {
                                    var _a;
                                    var rows = (_a = res.data) === null || _a === void 0 ? void 0 : _a.results;
                                    if (!rows || !Array.isArray(rows) || rows.length === 0) {
                                        pastpatPharmacy.value = [];
                                        newpastPatPharcy.value = false;
                                    }
                                    else {
                                        pastpatPharmacy.value = rows;
                                        newpastPatPharcy.value = true;
                                        newPharmloaded.value = false;
                                    }
                                })
                                    .catch(function () {
                                    pastpatPharmacy.value = [];
                                    newpastPatPharcy.value = false;
                                })];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        }
        (0, vue_3.onMounted)(function () {
            loadPatientPharmacy();
        });
        return function (_ctx, _cache) {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                _cache[78] || (_cache[78] = (0, vue_2.createElementVNode)("h3", { class: "section-title" }, "Pharmacy Information", -1)),
                (newpastPatPharcy.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_2, [
                        _cache[24] || (_cache[24] = (0, vue_2.createElementVNode)("label", null, "Select from Patient's Previous Pharmacies", -1)),
                        (0, vue_2.createElementVNode)("div", _hoisted_3, [
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(visiblePastPatPharmacy.value, function (ppharm, index) {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                    key: index,
                                    class: "pharmacy-item",
                                    style: { "display": "flex", "align-items": "center", "justify-content": "space-between", "padding": "12px", "border": "1px solid #ddd", "border-radius": "6px", "background-color": "#fff" }
                                }, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_4, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_5, (0, vue_2.toDisplayString)(ppharm.pharmacyname), 1),
                                        (0, vue_2.createElementVNode)("div", _hoisted_6, [
                                            (ppharm.npinumber)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_7, "NPI: " + (0, vue_2.toDisplayString)(ppharm.npinumber), 1))
                                                : (0, vue_2.createCommentVNode)("", true),
                                            (ppharm.pharmaddress)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_8, (0, vue_2.toDisplayString)(ppharm.pharmaddress), 1))
                                                : (0, vue_2.createCommentVNode)("", true)
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_9, [
                                        (0, vue_2.createElementVNode)("button", {
                                            type: "button",
                                            onClick: function ($event) { return (usePastPharmacy(index)); },
                                            style: { "padding": "6px 12px", "background-color": "#2196f3", "color": "white", "border": "none", "border-radius": "4px", "cursor": "pointer", "font-size": "0.85em" },
                                            title: "Use this pharmacy"
                                        }, __spreadArray([], (_cache[22] || (_cache[22] = [
                                            (0, vue_2.createElementVNode)("i", { class: "fas fa-check" }, null, -1),
                                            (0, vue_2.createTextVNode)(" Use ", -1)
                                        ])), true), 8, _hoisted_10)
                                    ])
                                ]));
                            }), 128)),
                            (showMorePharmacies.value)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_11, [
                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(hiddenPastPatPharmacy.value, function (ppharm, index) {
                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                            key: index + 2,
                                            class: "pharmacy-item",
                                            style: { "display": "flex", "align-items": "center", "justify-content": "space-between", "padding": "12px", "border": "1px solid #ddd", "border-radius": "6px", "background-color": "#fff" }
                                        }, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_12, [
                                                (0, vue_2.createElementVNode)("div", _hoisted_13, (0, vue_2.toDisplayString)(ppharm.pharmacyname), 1),
                                                (0, vue_2.createElementVNode)("div", _hoisted_14, [
                                                    (ppharm.npinumber)
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_15, "NPI: " + (0, vue_2.toDisplayString)(ppharm.npinumber), 1))
                                                        : (0, vue_2.createCommentVNode)("", true),
                                                    (ppharm.pharmaddress)
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_16, (0, vue_2.toDisplayString)(ppharm.pharmaddress), 1))
                                                        : (0, vue_2.createCommentVNode)("", true)
                                                ])
                                            ]),
                                            (0, vue_2.createElementVNode)("div", _hoisted_17, [
                                                (0, vue_2.createElementVNode)("button", {
                                                    type: "button",
                                                    onClick: function ($event) { return (usePastPharmacy(index + 2)); },
                                                    style: { "padding": "6px 12px", "background-color": "#2196f3", "color": "white", "border": "none", "border-radius": "4px", "cursor": "pointer", "font-size": "0.85em" },
                                                    title: "Use this pharmacy"
                                                }, __spreadArray([], (_cache[23] || (_cache[23] = [
                                                    (0, vue_2.createElementVNode)("i", { class: "fas fa-check" }, null, -1),
                                                    (0, vue_2.createTextVNode)(" Use ", -1)
                                                ])), true), 8, _hoisted_18)
                                            ])
                                        ]));
                                    }), 128))
                                ]))
                                : (0, vue_2.createCommentVNode)("", true),
                            (hiddenPastPatPharmacy.value.length > 0)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                    key: 1,
                                    type: "button",
                                    onClick: _cache[0] || (_cache[0] = function ($event) { return (showMorePharmacies.value = !showMorePharmacies.value); }),
                                    style: { "padding": "8px 16px", "background-color": "#f5f5f5", "color": "#333", "border": "1px solid #ddd", "border-radius": "4px", "cursor": "pointer", "font-size": "0.9em", "align-self": "flex-start" }
                                }, [
                                    (0, vue_2.createElementVNode)("i", {
                                        class: (0, vue_2.normalizeClass)(["fas", showMorePharmacies.value ? 'fa-chevron-up' : 'fa-chevron-down']),
                                        style: { "margin-right": "5px" }
                                    }, null, 2),
                                    (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(showMorePharmacies.value ? 'Show Less' : "Show More (".concat(hiddenPastPatPharmacy.value.length, ")")), 1)
                                ]))
                                : (0, vue_2.createCommentVNode)("", true)
                        ])
                    ]))
                    : (0, vue_2.createCommentVNode)("", true),
                (0, vue_2.createElementVNode)("div", _hoisted_19, [
                    _cache[71] || (_cache[71] = (0, vue_2.createElementVNode)("label", null, "Search for Pharmacy", -1)),
                    (0, vue_2.createElementVNode)("div", _hoisted_20, [
                        (0, vue_2.createElementVNode)("div", _hoisted_21, [
                            _cache[25] || (_cache[25] = (0, vue_2.createElementVNode)("label", null, "Pharmacy Name (Optional)", -1)),
                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                type: "text",
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((pharmacySearch.value.name) = $event); }),
                                placeholder: "Pharmacy Name (leave blank to search all pharmacies)",
                                onKeyup: (0, vue_2.withKeys)(handlePharmacySearch, ["enter"]),
                                onInput: onPharmacyNameInput
                            }, null, 544), [
                                [vue_2.vModelText, pharmacySearch.value.name]
                            ])
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_22, [
                        (0, vue_2.createElementVNode)("div", _hoisted_23, [
                            _cache[26] || (_cache[26] = (0, vue_2.createElementVNode)("label", null, "Telephone Number", -1)),
                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                type: "tel",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return ((pharmacySearch.value.telephone) = $event); }),
                                onBlur: _cache[3] || (_cache[3] = function ($event) { return (pharmacySearchTelephoneError.value = validatePhoneNumber(pharmacySearch.value.telephone)); }),
                                onInput: _cache[4] || (_cache[4] = function ($event) { return (handlePhoneInput(pharmacySearch.value.telephone, pharmacySearchTelephoneError.value, triggerDebouncedPharmacySearch)); }),
                                placeholder: "Phone Number (e.g., 5551234567)",
                                onKeyup: (0, vue_2.withKeys)(handlePharmacySearch, ["enter"]),
                                style: { "width": "100%", "box-sizing": "border-box" }
                            }, null, 544), [
                                [vue_2.vModelText, pharmacySearch.value.telephone]
                            ]),
                            (pharmacySearchTelephoneError.value)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_24, (0, vue_2.toDisplayString)(pharmacySearchTelephoneError.value), 1))
                                : (0, vue_2.createCommentVNode)("", true)
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_25, [
                            _cache[27] || (_cache[27] = (0, vue_2.createElementVNode)("label", null, "City", -1)),
                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                type: "text",
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) { return ((pharmacySearch.value.city) = $event); }),
                                placeholder: "City",
                                onKeyup: (0, vue_2.withKeys)(handlePharmacySearch, ["enter"]),
                                onInput: triggerDebouncedPharmacySearch,
                                style: { "width": "100%", "box-sizing": "border-box" }
                            }, null, 544), [
                                [vue_2.vModelText, pharmacySearch.value.city]
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_26, [
                            _cache[28] || (_cache[28] = (0, vue_2.createElementVNode)("label", null, "State", -1)),
                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                type: "text",
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) { return ((pharmacySearch.value.state) = $event); }),
                                placeholder: "State (e.g., NY)",
                                maxlength: "2",
                                onKeyup: (0, vue_2.withKeys)(handlePharmacySearch, ["enter"]),
                                onInput: triggerDebouncedPharmacySearch,
                                style: { "width": "100%", "box-sizing": "border-box" }
                            }, null, 544), [
                                [vue_2.vModelText, pharmacySearch.value.state]
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_27, [
                            _cache[29] || (_cache[29] = (0, vue_2.createElementVNode)("label", null, "ZIP Code", -1)),
                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                type: "text",
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) { return ((pharmacySearch.value.postal_code) = $event); }),
                                placeholder: "ZIP Code (required if no name)",
                                onKeyup: (0, vue_2.withKeys)(handlePharmacySearch, ["enter"]),
                                onInput: triggerDebouncedPharmacySearch,
                                style: { "width": "100%", "box-sizing": "border-box" }
                            }, null, 544), [
                                [vue_2.vModelText, pharmacySearch.value.postal_code]
                            ])
                        ])
                    ]),
                    (pharmacySearchHint.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_28, [
                            _cache[30] || (_cache[30] = (0, vue_2.createElementVNode)("i", {
                                class: "fas fa-info-circle",
                                style: { "margin-right": "5px" }
                            }, null, -1)),
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(pharmacySearchHint.value), 1)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (0, vue_2.createElementVNode)("button", {
                        type: "button",
                        class: "search-button",
                        onClick: handlePharmacySearch,
                        disabled: !canSearchPharmacy.value,
                        title: !canSearchPharmacy.value ? 'Please enter a pharmacy name, telephone number, or at least one location (city, state, or ZIP code)' : ''
                    }, " Search Pharmacy ", 8, _hoisted_29),
                    (newPharmloaded.value && pharmacySearchResults.value.length > 0)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_30, [
                            (0, vue_2.createElementVNode)("div", _hoisted_31, [
                                (0, vue_2.createElementVNode)("span", null, "Search Results (" + (0, vue_2.toDisplayString)(pharmacySearchResults.value.length) + ")", 1),
                                (pharmacySearchHiddenCount.value > 0)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_32, "Showing " + (0, vue_2.toDisplayString)(displayedPharmacySearchResults.value.length) + " of " + (0, vue_2.toDisplayString)(pharmacySearchResults.value.length), 1))
                                    : (0, vue_2.createCommentVNode)("", true)
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_33, [
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(displayedPharmacySearchResults.value, function (pharm, index) {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                        key: (pharm.npi || '') + '-' + index,
                                        class: "pharmacy-result-wrapper pharmacy-result-card"
                                    }, [
                                        (0, vue_2.createElementVNode)("div", {
                                            class: "pharmacy-summary pharmacy-summary-row",
                                            onMouseenter: _cache[8] || (_cache[8] = function ($event) { return (onPharmacySummaryEnter($event)); }),
                                            onMouseleave: _cache[9] || (_cache[9] = function ($event) { return (onPharmacySummaryLeave($event)); })
                                        }, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_34, [
                                                (0, vue_2.createElementVNode)("div", {
                                                    onClick: (0, vue_2.withModifiers)(function ($event) { return (togglePharmacyAccordion(index)); }, ["stop"]),
                                                    style: (0, vue_2.normalizeStyle)([{ "width": "24px", "height": "24px", "display": "flex", "align-items": "center", "justify-content": "center", "cursor": "pointer", "color": "#666", "transition": "transform 0.3s" }, { transform: expandedPharmacyIndex.value === index ? 'rotate(90deg)' : 'rotate(0deg)' }]),
                                                    title: expandedPharmacyIndex.value === index ? 'Hide details' : 'Show details'
                                                }, __spreadArray([], (_cache[31] || (_cache[31] = [
                                                    (0, vue_2.createElementVNode)("i", { class: "fas fa-chevron-right" }, null, -1)
                                                ])), true), 12, _hoisted_35),
                                                (0, vue_2.createElementVNode)("div", {
                                                    onClick: function ($event) { return (selectPharm(index)); },
                                                    style: { "flex": "1" }
                                                }, [
                                                    (0, vue_2.createElementVNode)("div", _hoisted_37, [
                                                        (0, vue_2.createElementVNode)("strong", _hoisted_38, (0, vue_2.toDisplayString)(pharm.name), 1),
                                                        (0, vue_2.createElementVNode)("span", _hoisted_39, "NPI: " + (0, vue_2.toDisplayString)(pharm.npi), 1)
                                                    ]),
                                                    (0, vue_2.createElementVNode)("div", _hoisted_40, (0, vue_2.toDisplayString)(formatPharmacyAddress(pharm.address) || 'No address available'), 1),
                                                    (pharm.telephone)
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_41, [
                                                            _cache[32] || (_cache[32] = (0, vue_2.createElementVNode)("i", {
                                                                class: "fas fa-phone",
                                                                style: { "margin-right": "4px" }
                                                            }, null, -1)),
                                                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(pharm.telephone), 1)
                                                        ]))
                                                        : (0, vue_2.createCommentVNode)("", true)
                                                ], 8, _hoisted_36)
                                            ])
                                        ], 32),
                                        (expandedPharmacyIndex.value === index)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                key: 0,
                                                class: "pharmacy-details",
                                                onClick: _cache[10] || (_cache[10] = (0, vue_2.withModifiers)(function () { }, ["stop"])),
                                                style: { "padding": "15px", "background-color": "#fafafa", "border-top": "2px solid #4caf50" }
                                            }, [
                                                _cache[44] || (_cache[44] = (0, vue_2.createElementVNode)("div", { style: { "margin-bottom": "15px", "display": "flex", "align-items": "center", "justify-content": "space-between" } }, [
                                                    (0, vue_2.createElementVNode)("h5", { style: { "margin": "0", "color": "#333", "font-size": "1em", "font-weight": "600" } }, [
                                                        (0, vue_2.createElementVNode)("i", {
                                                            class: "fas fa-edit",
                                                            style: { "margin-right": "5px", "color": "#2196f3" }
                                                        }),
                                                        (0, vue_2.createTextVNode)(" Edit Pharmacy Details ")
                                                    ]),
                                                    (0, vue_2.createElementVNode)("span", { style: { "font-size": "0.85em", "color": "#666" } }, "Fill in empty fields or update existing information")
                                                ], -1)),
                                                (0, vue_2.createElementVNode)("div", _hoisted_42, [
                                                    (0, vue_2.createElementVNode)("div", null, [
                                                        _cache[33] || (_cache[33] = (0, vue_2.createElementVNode)("label", { style: { "display": "block", "margin-bottom": "4px", "font-size": "0.85em", "color": "#666", "font-weight": "500" } }, "Pharmacy Name", -1)),
                                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                            type: "text",
                                                            "onUpdate:modelValue": function ($event) { return ((editingPharmacyFields.value[index].name) = $event); },
                                                            style: { "width": "100%", "padding": "6px", "border": "1px solid #ddd", "border-radius": "4px", "font-size": "0.9em" },
                                                            placeholder: "Pharmacy Name"
                                                        }, null, 8, _hoisted_43), [
                                                            [vue_2.vModelText, editingPharmacyFields.value[index].name]
                                                        ])
                                                    ]),
                                                    (0, vue_2.createElementVNode)("div", null, [
                                                        _cache[34] || (_cache[34] = (0, vue_2.createElementVNode)("label", { style: { "display": "block", "margin-bottom": "4px", "font-size": "0.85em", "color": "#666", "font-weight": "500" } }, "NPI Number", -1)),
                                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                            type: "text",
                                                            "onUpdate:modelValue": function ($event) { return ((editingPharmacyFields.value[index].npi) = $event); },
                                                            style: { "width": "100%", "padding": "6px", "border": "1px solid #ddd", "border-radius": "4px", "font-size": "0.9em" },
                                                            placeholder: "NPI Number"
                                                        }, null, 8, _hoisted_44), [
                                                            [vue_2.vModelText, editingPharmacyFields.value[index].npi]
                                                        ])
                                                    ]),
                                                    (0, vue_2.createElementVNode)("div", null, [
                                                        _cache[35] || (_cache[35] = (0, vue_2.createElementVNode)("label", { style: { "display": "block", "margin-bottom": "4px", "font-size": "0.85em", "color": "#666", "font-weight": "500" } }, "Address Line 1", -1)),
                                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                            type: "text",
                                                            "onUpdate:modelValue": function ($event) { return ((editingPharmacyFields.value[index].addressLine1) = $event); },
                                                            style: { "width": "100%", "padding": "6px", "border": "1px solid #ddd", "border-radius": "4px", "font-size": "0.9em" },
                                                            placeholder: "Street Address"
                                                        }, null, 8, _hoisted_45), [
                                                            [vue_2.vModelText, editingPharmacyFields.value[index].addressLine1]
                                                        ])
                                                    ]),
                                                    (0, vue_2.createElementVNode)("div", null, [
                                                        _cache[36] || (_cache[36] = (0, vue_2.createElementVNode)("label", { style: { "display": "block", "margin-bottom": "4px", "font-size": "0.85em", "color": "#666", "font-weight": "500" } }, "Address Line 2", -1)),
                                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                            type: "text",
                                                            "onUpdate:modelValue": function ($event) { return ((editingPharmacyFields.value[index].addressLine2) = $event); },
                                                            style: { "width": "100%", "padding": "6px", "border": "1px solid #ddd", "border-radius": "4px", "font-size": "0.9em" },
                                                            placeholder: "Suite, Unit, etc."
                                                        }, null, 8, _hoisted_46), [
                                                            [vue_2.vModelText, editingPharmacyFields.value[index].addressLine2]
                                                        ])
                                                    ]),
                                                    (0, vue_2.createElementVNode)("div", null, [
                                                        _cache[37] || (_cache[37] = (0, vue_2.createElementVNode)("label", { style: { "display": "block", "margin-bottom": "4px", "font-size": "0.85em", "color": "#666", "font-weight": "500" } }, "City", -1)),
                                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                            type: "text",
                                                            "onUpdate:modelValue": function ($event) { return ((editingPharmacyFields.value[index].city) = $event); },
                                                            style: { "width": "100%", "padding": "6px", "border": "1px solid #ddd", "border-radius": "4px", "font-size": "0.9em" },
                                                            placeholder: "City"
                                                        }, null, 8, _hoisted_47), [
                                                            [vue_2.vModelText, editingPharmacyFields.value[index].city]
                                                        ])
                                                    ]),
                                                    (0, vue_2.createElementVNode)("div", null, [
                                                        _cache[38] || (_cache[38] = (0, vue_2.createElementVNode)("label", { style: { "display": "block", "margin-bottom": "4px", "font-size": "0.85em", "color": "#666", "font-weight": "500" } }, "State", -1)),
                                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                            type: "text",
                                                            "onUpdate:modelValue": function ($event) { return ((editingPharmacyFields.value[index].state) = $event); },
                                                            maxlength: "2",
                                                            style: { "width": "100%", "padding": "6px", "border": "1px solid #ddd", "border-radius": "4px", "font-size": "0.9em", "text-transform": "uppercase" },
                                                            placeholder: "State (e.g., NY)"
                                                        }, null, 8, _hoisted_48), [
                                                            [vue_2.vModelText, editingPharmacyFields.value[index].state]
                                                        ])
                                                    ]),
                                                    (0, vue_2.createElementVNode)("div", null, [
                                                        _cache[39] || (_cache[39] = (0, vue_2.createElementVNode)("label", { style: { "display": "block", "margin-bottom": "4px", "font-size": "0.85em", "color": "#666", "font-weight": "500" } }, "ZIP Code", -1)),
                                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                            type: "text",
                                                            "onUpdate:modelValue": function ($event) { return ((editingPharmacyFields.value[index].postalCode) = $event); },
                                                            style: { "width": "100%", "padding": "6px", "border": "1px solid #ddd", "border-radius": "4px", "font-size": "0.9em" },
                                                            placeholder: "ZIP Code"
                                                        }, null, 8, _hoisted_49), [
                                                            [vue_2.vModelText, editingPharmacyFields.value[index].postalCode]
                                                        ])
                                                    ]),
                                                    (0, vue_2.createElementVNode)("div", null, [
                                                        _cache[40] || (_cache[40] = (0, vue_2.createElementVNode)("label", { style: { "display": "block", "margin-bottom": "4px", "font-size": "0.85em", "color": "#666", "font-weight": "500" } }, "Phone Number", -1)),
                                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                            type: "tel",
                                                            "onUpdate:modelValue": function ($event) { return ((editingPharmacyFields.value[index].telephone) = $event); },
                                                            style: { "width": "100%", "padding": "6px", "border": "1px solid #ddd", "border-radius": "4px", "font-size": "0.9em" },
                                                            placeholder: "Phone Number"
                                                        }, null, 8, _hoisted_50), [
                                                            [vue_2.vModelText, editingPharmacyFields.value[index].telephone]
                                                        ])
                                                    ])
                                                ]),
                                                (0, vue_2.createElementVNode)("div", _hoisted_51, [
                                                    (0, vue_2.createElementVNode)("button", {
                                                        type: "button",
                                                        onClick: function ($event) { return (applyPharmacyEdits(index)); },
                                                        style: { "padding": "8px 16px", "background-color": "#4caf50", "color": "white", "border": "none", "border-radius": "4px", "cursor": "pointer", "font-size": "0.9em", "font-weight": "500" }
                                                    }, __spreadArray([], (_cache[41] || (_cache[41] = [
                                                        (0, vue_2.createElementVNode)("i", {
                                                            class: "fas fa-check",
                                                            style: { "margin-right": "5px" }
                                                        }, null, -1),
                                                        (0, vue_2.createTextVNode)("Apply Changes ", -1)
                                                    ])), true), 8, _hoisted_52),
                                                    (0, vue_2.createElementVNode)("button", {
                                                        type: "button",
                                                        onClick: function ($event) { return (selectPharmWithEdits(index)); },
                                                        style: { "padding": "8px 16px", "background-color": "#2196f3", "color": "white", "border": "none", "border-radius": "4px", "cursor": "pointer", "font-size": "0.9em", "font-weight": "500" }
                                                    }, __spreadArray([], (_cache[42] || (_cache[42] = [
                                                        (0, vue_2.createElementVNode)("i", {
                                                            class: "fas fa-check-circle",
                                                            style: { "margin-right": "5px" }
                                                        }, null, -1),
                                                        (0, vue_2.createTextVNode)("Select with Edits ", -1)
                                                    ])), true), 8, _hoisted_53),
                                                    (0, vue_2.createElementVNode)("button", {
                                                        type: "button",
                                                        onClick: function ($event) { return (resetPharmacyEdits(index)); },
                                                        style: { "padding": "8px 16px", "background-color": "#757575", "color": "white", "border": "none", "border-radius": "4px", "cursor": "pointer", "font-size": "0.9em" }
                                                    }, __spreadArray([], (_cache[43] || (_cache[43] = [
                                                        (0, vue_2.createElementVNode)("i", {
                                                            class: "fas fa-undo",
                                                            style: { "margin-right": "5px" }
                                                        }, null, -1),
                                                        (0, vue_2.createTextVNode)("Reset ", -1)
                                                    ])), true), 8, _hoisted_54)
                                                ])
                                            ]))
                                            : (0, vue_2.createCommentVNode)("", true)
                                    ]));
                                }), 128))
                            ]),
                            (pharmacySearchResults.value.length > PHARMACY_SEARCH_PAGE_SIZE)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_55, [
                                    (pharmacySearchHiddenCount.value > 0)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                            key: 0,
                                            type: "button",
                                            class: "pharmacy-pager-btn",
                                            onClick: showMorePharmacySearchResults
                                        }, [
                                            _cache[45] || (_cache[45] = (0, vue_2.createElementVNode)("i", {
                                                class: "fas fa-chevron-down",
                                                style: { "margin-right": "6px" }
                                            }, null, -1)),
                                            (0, vue_2.createTextVNode)(" Show more (" + (0, vue_2.toDisplayString)(pharmacySearchHiddenCount.value) + " more) ", 1)
                                        ]))
                                        : (0, vue_2.createCommentVNode)("", true),
                                    (pharmacySearchHiddenCount.value > 0 && pharmacySearchHiddenCount.value > PHARMACY_SEARCH_PAGE_SIZE)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                            key: 1,
                                            type: "button",
                                            class: "pharmacy-pager-btn pharmacy-pager-secondary",
                                            onClick: showAllPharmacySearchResults
                                        }, " Show all " + (0, vue_2.toDisplayString)(pharmacySearchResults.value.length), 1))
                                        : (0, vue_2.createCommentVNode)("", true),
                                    (pharmacySearchVisibleCount.value > PHARMACY_SEARCH_PAGE_SIZE && pharmacySearchHiddenCount.value === 0)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                            key: 2,
                                            type: "button",
                                            class: "pharmacy-pager-btn pharmacy-pager-secondary",
                                            onClick: collapsePharmacySearchResults
                                        }, __spreadArray([], (_cache[46] || (_cache[46] = [
                                            (0, vue_2.createElementVNode)("i", {
                                                class: "fas fa-chevron-up",
                                                style: { "margin-right": "6px" }
                                            }, null, -1),
                                            (0, vue_2.createTextVNode)(" Show less ", -1)
                                        ])), true)))
                                        : (0, vue_2.createCommentVNode)("", true)
                                ]))
                                : (0, vue_2.createCommentVNode)("", true)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (newPharmloaded.value && pharmacySearchResults.value.length === 0)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_56, " No pharmacies found. Please try different search criteria. "))
                        : (0, vue_2.createCommentVNode)("", true),
                    (medForm.value.pharmacyName && medForm.value.pharmacyName.trim() !== '')
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_57, [
                            (0, vue_2.createElementVNode)("div", _hoisted_58, [
                                (0, vue_2.createElementVNode)("div", _hoisted_59, [
                                    _cache[47] || (_cache[47] = (0, vue_2.createElementVNode)("i", {
                                        class: "fas fa-check-circle",
                                        style: { "color": "#4caf50", "font-size": "1.2em", "margin-right": "10px" }
                                    }, null, -1)),
                                    (0, vue_2.createElementVNode)("h4", _hoisted_60, (0, vue_2.toDisplayString)(editingPharmacyIndex.value !== null ? 'Replace Pharmacy' : 'Selected Pharmacy'), 1)
                                ]),
                                (0, vue_2.createElementVNode)("button", {
                                    type: "button",
                                    onClick: clearSelectedPharmacy,
                                    style: { "padding": "4px 8px", "background-color": "transparent", "color": "#666", "border": "1px solid #ddd", "border-radius": "4px", "cursor": "pointer", "font-size": "0.9em" },
                                    title: "Close"
                                }, __spreadArray([], (_cache[48] || (_cache[48] = [
                                    (0, vue_2.createElementVNode)("i", { class: "fas fa-times" }, null, -1)
                                ])), true))
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_61, [
                                (0, vue_2.createElementVNode)("div", _hoisted_62, [
                                    _cache[49] || (_cache[49] = (0, vue_2.createElementVNode)("strong", { style: { "color": "#1b5e20" } }, "Name:", -1)),
                                    (0, vue_2.createElementVNode)("span", _hoisted_63, (0, vue_2.toDisplayString)(medForm.value.pharmacyName), 1)
                                ]),
                                (medForm.value.pharmacyNpi)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_64, [
                                        _cache[50] || (_cache[50] = (0, vue_2.createElementVNode)("strong", { style: { "color": "#1b5e20" } }, "NPI:", -1)),
                                        (0, vue_2.createElementVNode)("span", _hoisted_65, (0, vue_2.toDisplayString)(medForm.value.pharmacyNpi), 1)
                                    ]))
                                    : (0, vue_2.createCommentVNode)("", true),
                                (medForm.value.pharmacyAddress)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_66, [
                                        _cache[51] || (_cache[51] = (0, vue_2.createElementVNode)("strong", { style: { "color": "#1b5e20" } }, "Address:", -1)),
                                        (0, vue_2.createElementVNode)("span", _hoisted_67, (0, vue_2.toDisplayString)(medForm.value.pharmacyAddress), 1)
                                    ]))
                                    : (0, vue_2.createCommentVNode)("", true),
                                (medForm.value.pharmacyOffice)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_68, [
                                        _cache[52] || (_cache[52] = (0, vue_2.createElementVNode)("strong", { style: { "color": "#1b5e20" } }, "Phone:", -1)),
                                        (0, vue_2.createElementVNode)("span", _hoisted_69, (0, vue_2.toDisplayString)(medForm.value.pharmacyOffice), 1)
                                    ]))
                                    : (0, vue_2.createCommentVNode)("", true),
                                (0, vue_2.createElementVNode)("div", _hoisted_70, [
                                    (editingPharmacyIndex.value !== null)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                            key: 0,
                                            type: "button",
                                            onClick: saveSelectedPharmacy,
                                            style: { "padding": "8px 16px", "background-color": "#ff9800", "color": "white", "border": "none", "border-radius": "4px", "cursor": "pointer", "font-size": "0.9em", "font-weight": "500" }
                                        }, __spreadArray([], (_cache[53] || (_cache[53] = [
                                            (0, vue_2.createElementVNode)("i", {
                                                class: "fas fa-save",
                                                style: { "margin-right": "5px" }
                                            }, null, -1),
                                            (0, vue_2.createTextVNode)("Replace Pharmacy ", -1)
                                        ])), true)))
                                        : (0, vue_2.createCommentVNode)("", true),
                                    (isPharmacyAlreadySaved.value && editingPharmacyIndex.value === null)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_71, __spreadArray([], (_cache[54] || (_cache[54] = [
                                            (0, vue_2.createElementVNode)("i", {
                                                class: "fas fa-check-circle",
                                                style: { "margin-right": "5px" }
                                            }, null, -1),
                                            (0, vue_2.createTextVNode)("Already Saved ", -1)
                                        ])), true)))
                                        : (0, vue_2.createCommentVNode)("", true)
                                ])
                            ])
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (activePharmacies.value.length > 0 || retiredPharmacies.value.length > 0)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_72, [
                            (0, vue_2.createElementVNode)("div", _hoisted_73, [
                                (activePharmacies.value.length > 0)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("h4", _hoisted_74, [
                                        _cache[55] || (_cache[55] = (0, vue_2.createElementVNode)("i", {
                                            class: "fas fa-bookmark",
                                            style: { "margin-right": "8px" }
                                        }, null, -1)),
                                        (0, vue_2.createTextVNode)(" Active Pharmacies (" + (0, vue_2.toDisplayString)(activePharmacies.value.length) + ") ", 1)
                                    ]))
                                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("h4", _hoisted_75, __spreadArray([], (_cache[56] || (_cache[56] = [
                                        (0, vue_2.createElementVNode)("i", {
                                            class: "fas fa-history",
                                            style: { "margin-right": "8px" }
                                        }, null, -1),
                                        (0, vue_2.createTextVNode)(" Pharmacy History ", -1)
                                    ])), true))),
                                (retiredPharmacies.value.length > 0)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                        key: 2,
                                        type: "button",
                                        onClick: _cache[11] || (_cache[11] = function ($event) { return (showRetiredPharmacies.value = !showRetiredPharmacies.value); }),
                                        style: (0, vue_2.normalizeStyle)({
                                            padding: '8px 16px',
                                            backgroundColor: showRetiredPharmacies.value ? '#4caf50' : '#757575',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                            fontSize: '0.9em',
                                            fontWeight: '500'
                                        })
                                    }, [
                                        _cache[57] || (_cache[57] = (0, vue_2.createElementVNode)("i", {
                                            class: "fas fa-history",
                                            style: { "margin-right": "5px" }
                                        }, null, -1)),
                                        (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(showRetiredPharmacies.value ? 'Hide' : 'Show') + " Retired (" + (0, vue_2.toDisplayString)(retiredPharmacies.value.length) + ") ", 1)
                                    ], 4))
                                    : (0, vue_2.createCommentVNode)("", true)
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_76, [
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(activePharmacies.value, function (pharm, index) {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                        key: index,
                                        class: "saved-pharmacy-wrapper",
                                        style: { "border": "1px solid #ddd", "border-radius": "6px", "overflow": "hidden", "background-color": "#fff", "width": "100%", "box-sizing": "border-box", "max-width": "100%" }
                                    }, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_77, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_78, [
                                                (0, vue_2.createElementVNode)("div", _hoisted_79, (0, vue_2.toDisplayString)(pharm.name), 1),
                                                (0, vue_2.createElementVNode)("div", _hoisted_80, [
                                                    (pharm.npi)
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_81, "NPI: " + (0, vue_2.toDisplayString)(pharm.npi), 1))
                                                        : (0, vue_2.createCommentVNode)("", true),
                                                    (pharm.npi && pharm.address)
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_82, " ?? "))
                                                        : (0, vue_2.createCommentVNode)("", true),
                                                    (pharm.address)
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_83, (0, vue_2.toDisplayString)(pharm.address), 1))
                                                        : (0, vue_2.createCommentVNode)("", true),
                                                    (pharm.dateAdded)
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_84, " Added: " + (0, vue_2.toDisplayString)(formatDate(pharm.dateAdded)), 1))
                                                        : (0, vue_2.createCommentVNode)("", true)
                                                ])
                                            ]),
                                            (0, vue_2.createElementVNode)("div", _hoisted_85, [
                                                (0, vue_2.createElementVNode)("button", {
                                                    type: "button",
                                                    onClick: function ($event) { return (selectSavedPharmacy(index)); },
                                                    style: { "padding": "6px 12px", "background-color": "#2196f3", "color": "white", "border": "none", "border-radius": "4px", "cursor": "pointer", "font-size": "0.85em" },
                                                    title: "Use this pharmacy"
                                                }, __spreadArray([], (_cache[58] || (_cache[58] = [
                                                    (0, vue_2.createElementVNode)("i", { class: "fas fa-check" }, null, -1),
                                                    (0, vue_2.createTextVNode)(" Use ", -1)
                                                ])), true), 8, _hoisted_86),
                                                (0, vue_2.createElementVNode)("button", {
                                                    type: "button",
                                                    onClick: function ($event) { return (editSavedPharmacy(index)); },
                                                    style: { "padding": "6px 12px", "background-color": "#ff9800", "color": "white", "border": "none", "border-radius": "4px", "cursor": "pointer", "font-size": "0.85em" },
                                                    title: "Edit pharmacy in main form"
                                                }, __spreadArray([], (_cache[59] || (_cache[59] = [
                                                    (0, vue_2.createElementVNode)("i", { class: "fas fa-edit" }, null, -1),
                                                    (0, vue_2.createTextVNode)(" Edit ", -1)
                                                ])), true), 8, _hoisted_87)
                                            ])
                                        ]),
                                        (expandedSavedPharmacyIndex.value === index)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_88, [
                                                _cache[68] || (_cache[68] = (0, vue_2.createElementVNode)("div", { style: { "margin-bottom": "15px" } }, [
                                                    (0, vue_2.createElementVNode)("h5", { style: { "margin": "0 0 10px 0", "color": "#333", "font-size": "1em", "font-weight": "600" } }, [
                                                        (0, vue_2.createElementVNode)("i", {
                                                            class: "fas fa-edit",
                                                            style: { "margin-right": "5px", "color": "#ff9800" }
                                                        }),
                                                        (0, vue_2.createTextVNode)(" Edit Pharmacy Details ")
                                                    ]),
                                                    (0, vue_2.createElementVNode)("p", { style: { "margin": "0", "font-size": "0.85em", "color": "#666" } }, "Complete blank fields or update existing information")
                                                ], -1)),
                                                (0, vue_2.createElementVNode)("div", _hoisted_89, [
                                                    (0, vue_2.createElementVNode)("div", null, [
                                                        _cache[60] || (_cache[60] = (0, vue_2.createElementVNode)("label", { style: { "display": "block", "margin-bottom": "4px", "font-size": "0.85em", "color": "#666", "font-weight": "500" } }, "Pharmacy Name", -1)),
                                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                            type: "text",
                                                            "onUpdate:modelValue": function ($event) { return ((editingSavedPharmacyFields.value[index].name) = $event); },
                                                            style: { "width": "100%", "padding": "6px", "border": "1px solid #ddd", "border-radius": "4px", "font-size": "0.9em" },
                                                            placeholder: "Pharmacy Name"
                                                        }, null, 8, _hoisted_90), [
                                                            [vue_2.vModelText, editingSavedPharmacyFields.value[index].name]
                                                        ])
                                                    ]),
                                                    (0, vue_2.createElementVNode)("div", null, [
                                                        _cache[61] || (_cache[61] = (0, vue_2.createElementVNode)("label", { style: { "display": "block", "margin-bottom": "4px", "font-size": "0.85em", "color": "#666", "font-weight": "500" } }, "NPI Number", -1)),
                                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                            type: "text",
                                                            "onUpdate:modelValue": function ($event) { return ((editingSavedPharmacyFields.value[index].npi) = $event); },
                                                            style: { "width": "100%", "padding": "6px", "border": "1px solid #ddd", "border-radius": "4px", "font-size": "0.9em" },
                                                            placeholder: "NPI Number"
                                                        }, null, 8, _hoisted_91), [
                                                            [vue_2.vModelText, editingSavedPharmacyFields.value[index].npi]
                                                        ])
                                                    ]),
                                                    (0, vue_2.createElementVNode)("div", null, [
                                                        _cache[62] || (_cache[62] = (0, vue_2.createElementVNode)("label", { style: { "display": "block", "margin-bottom": "4px", "font-size": "0.85em", "color": "#666", "font-weight": "500" } }, "DEA Number", -1)),
                                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                            type: "text",
                                                            "onUpdate:modelValue": function ($event) { return ((editingSavedPharmacyFields.value[index].dea) = $event); },
                                                            style: { "width": "100%", "padding": "6px", "border": "1px solid #ddd", "border-radius": "4px", "font-size": "0.9em" },
                                                            placeholder: "DEA Number"
                                                        }, null, 8, _hoisted_92), [
                                                            [vue_2.vModelText, editingSavedPharmacyFields.value[index].dea]
                                                        ])
                                                    ]),
                                                    (0, vue_2.createElementVNode)("div", null, [
                                                        _cache[63] || (_cache[63] = (0, vue_2.createElementVNode)("label", { style: { "display": "block", "margin-bottom": "4px", "font-size": "0.85em", "color": "#666", "font-weight": "500" } }, "Address", -1)),
                                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                            type: "text",
                                                            "onUpdate:modelValue": function ($event) { return ((editingSavedPharmacyFields.value[index].address) = $event); },
                                                            style: { "width": "100%", "padding": "6px", "border": "1px solid #ddd", "border-radius": "4px", "font-size": "0.9em" },
                                                            placeholder: "Full Address"
                                                        }, null, 8, _hoisted_93), [
                                                            [vue_2.vModelText, editingSavedPharmacyFields.value[index].address]
                                                        ])
                                                    ]),
                                                    (0, vue_2.createElementVNode)("div", null, [
                                                        _cache[64] || (_cache[64] = (0, vue_2.createElementVNode)("label", { style: { "display": "block", "margin-bottom": "4px", "font-size": "0.85em", "color": "#666", "font-weight": "500" } }, "Office Number", -1)),
                                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                            type: "tel",
                                                            "onUpdate:modelValue": function ($event) { return ((editingSavedPharmacyFields.value[index].phone) = $event); },
                                                            style: { "width": "100%", "padding": "6px", "border": "1px solid #ddd", "border-radius": "4px", "font-size": "0.9em" },
                                                            placeholder: "Office Phone"
                                                        }, null, 8, _hoisted_94), [
                                                            [vue_2.vModelText, editingSavedPharmacyFields.value[index].phone]
                                                        ])
                                                    ]),
                                                    (0, vue_2.createElementVNode)("div", null, [
                                                        _cache[65] || (_cache[65] = (0, vue_2.createElementVNode)("label", { style: { "display": "block", "margin-bottom": "4px", "font-size": "0.85em", "color": "#666", "font-weight": "500" } }, "Cell Phone", -1)),
                                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                            type: "tel",
                                                            "onUpdate:modelValue": function ($event) { return ((editingSavedPharmacyFields.value[index].cell) = $event); },
                                                            style: { "width": "100%", "padding": "6px", "border": "1px solid #ddd", "border-radius": "4px", "font-size": "0.9em" },
                                                            placeholder: "Cell Phone"
                                                        }, null, 8, _hoisted_95), [
                                                            [vue_2.vModelText, editingSavedPharmacyFields.value[index].cell]
                                                        ])
                                                    ])
                                                ]),
                                                (0, vue_2.createElementVNode)("div", _hoisted_96, [
                                                    (0, vue_2.createElementVNode)("button", {
                                                        type: "button",
                                                        onClick: function ($event) { return (saveSavedPharmacyEdits(index)); },
                                                        disabled: !canSaveSavedPharmacyEdits(index),
                                                        style: (0, vue_2.normalizeStyle)({
                                                            padding: '8px 16px',
                                                            backgroundColor: canSaveSavedPharmacyEdits(index) ? '#4caf50' : '#b2d8d8',
                                                            color: 'white',
                                                            border: 'none',
                                                            borderRadius: '4px',
                                                            cursor: canSaveSavedPharmacyEdits(index) ? 'pointer' : 'not-allowed',
                                                            fontSize: '0.9em',
                                                            fontWeight: '500',
                                                            opacity: canSaveSavedPharmacyEdits(index) ? 1 : 0.6
                                                        })
                                                    }, __spreadArray([], (_cache[66] || (_cache[66] = [
                                                        (0, vue_2.createElementVNode)("i", {
                                                            class: "fas fa-save",
                                                            style: { "margin-right": "5px" }
                                                        }, null, -1),
                                                        (0, vue_2.createTextVNode)("Save Changes ", -1)
                                                    ])), true), 12, _hoisted_97),
                                                    (0, vue_2.createElementVNode)("button", {
                                                        type: "button",
                                                        onClick: function ($event) { return (cancelSavedPharmacyEdit(index)); },
                                                        style: { "padding": "8px 16px", "background-color": "#757575", "color": "white", "border": "none", "border-radius": "4px", "cursor": "pointer", "font-size": "0.9em" }
                                                    }, __spreadArray([], (_cache[67] || (_cache[67] = [
                                                        (0, vue_2.createElementVNode)("i", {
                                                            class: "fas fa-times",
                                                            style: { "margin-right": "5px" }
                                                        }, null, -1),
                                                        (0, vue_2.createTextVNode)("Cancel ", -1)
                                                    ])), true), 8, _hoisted_98)
                                                ])
                                            ]))
                                            : (0, vue_2.createCommentVNode)("", true)
                                    ]));
                                }), 128))
                            ])
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (showRetiredPharmacies.value && retiredPharmacies.value.length > 0)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_99, [
                            (0, vue_2.createElementVNode)("h4", _hoisted_100, [
                                _cache[69] || (_cache[69] = (0, vue_2.createElementVNode)("i", {
                                    class: "fas fa-history",
                                    style: { "margin-right": "8px" }
                                }, null, -1)),
                                (0, vue_2.createTextVNode)(" Retired Pharmacies History (" + (0, vue_2.toDisplayString)(retiredPharmacies.value.length) + ") ", 1)
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_101, [
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(retiredPharmacies.value, function (pharm, index) {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                        key: index,
                                        class: "retired-pharmacy-item",
                                        style: { "padding": "12px", "background-color": "#f5f5f5", "border": "1px solid #ddd", "border-radius": "6px", "opacity": "0.7" }
                                    }, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_102, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_103, [
                                                (0, vue_2.createElementVNode)("div", _hoisted_104, (0, vue_2.toDisplayString)(pharm.name), 1),
                                                (0, vue_2.createElementVNode)("div", _hoisted_105, [
                                                    (pharm.npi)
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_106, "NPI: " + (0, vue_2.toDisplayString)(pharm.npi), 1))
                                                        : (0, vue_2.createCommentVNode)("", true),
                                                    (pharm.npi && pharm.address)
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_107, " ?? "))
                                                        : (0, vue_2.createCommentVNode)("", true),
                                                    (pharm.address)
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_108, (0, vue_2.toDisplayString)(pharm.address), 1))
                                                        : (0, vue_2.createCommentVNode)("", true),
                                                    (pharm.dateRetired)
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_109, " Retired: " + (0, vue_2.toDisplayString)(formatDate(pharm.dateRetired)), 1))
                                                        : (0, vue_2.createCommentVNode)("", true)
                                                ])
                                            ]),
                                            (0, vue_2.createElementVNode)("button", {
                                                type: "button",
                                                onClick: function ($event) { return (restorePharmacy(index)); },
                                                style: { "padding": "6px 12px", "background-color": "#4caf50", "color": "white", "border": "none", "border-radius": "4px", "cursor": "pointer", "font-size": "0.85em" },
                                                title: "Restore this pharmacy"
                                            }, __spreadArray([], (_cache[70] || (_cache[70] = [
                                                (0, vue_2.createElementVNode)("i", { class: "fas fa-undo" }, null, -1),
                                                (0, vue_2.createTextVNode)(" Restore ", -1)
                                            ])), true), 8, _hoisted_110)
                                        ])
                                    ]));
                                }), 128))
                            ])
                        ]))
                        : (0, vue_2.createCommentVNode)("", true)
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_111, [
                    (0, vue_2.createElementVNode)("div", _hoisted_112, [
                        _cache[72] || (_cache[72] = (0, vue_2.createElementVNode)("label", null, "DEA Number", -1)),
                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = function ($event) { return ((medForm.value.pharmacyDea) = $event); }),
                            placeholder: "DEA Number"
                        }, null, 512), [
                            [vue_2.vModelText, medForm.value.pharmacyDea]
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_113, [
                        _cache[73] || (_cache[73] = (0, vue_2.createElementVNode)("label", null, "NPI Number", -1)),
                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = function ($event) { return ((medForm.value.pharmacyNpi) = $event); }),
                            placeholder: "NPI Number"
                        }, null, 512), [
                            [vue_2.vModelText, medForm.value.pharmacyNpi]
                        ])
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_114, [
                    _cache[74] || (_cache[74] = (0, vue_2.createElementVNode)("label", null, "Address", -1)),
                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = function ($event) { return ((medForm.value.pharmacyAddress) = $event); }),
                        placeholder: "Address"
                    }, null, 512), [
                        [vue_2.vModelText, medForm.value.pharmacyAddress]
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_115, [
                    (0, vue_2.createElementVNode)("div", _hoisted_116, [
                        _cache[75] || (_cache[75] = (0, vue_2.createElementVNode)("label", null, "Office Number", -1)),
                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = function ($event) { return ((medForm.value.pharmacyOffice) = $event); }),
                            onBlur: _cache[16] || (_cache[16] = function ($event) { return (pharmacyOfficeError.value = validatePhoneNumber(medForm.value.pharmacyOffice)); }),
                            onInput: _cache[17] || (_cache[17] = function ($event) { return (handlePhoneInput(medForm.value.pharmacyOffice, pharmacyOfficeError.value, 'pharmacyOffice')); }),
                            placeholder: "Office Number"
                        }, null, 544), [
                            [vue_2.vModelText, medForm.value.pharmacyOffice]
                        ]),
                        (pharmacyOfficeError.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_117, (0, vue_2.toDisplayString)(pharmacyOfficeError.value), 1))
                            : (0, vue_2.createCommentVNode)("", true)
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_118, [
                        _cache[76] || (_cache[76] = (0, vue_2.createElementVNode)("label", null, "Cell Phone", -1)),
                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = function ($event) { return ((medForm.value.pharmacyCell) = $event); }),
                            onBlur: _cache[19] || (_cache[19] = function ($event) { return (pharmacyCellError.value = validatePhoneNumber(medForm.value.pharmacyCell)); }),
                            onInput: _cache[20] || (_cache[20] = function ($event) { return (handlePhoneInput(medForm.value.pharmacyCell, pharmacyCellError.value, 'pharmacyCell')); }),
                            placeholder: "Cell Phone"
                        }, null, 544), [
                            [vue_2.vModelText, medForm.value.pharmacyCell]
                        ]),
                        (pharmacyCellError.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_119, (0, vue_2.toDisplayString)(pharmacyCellError.value), 1))
                            : (0, vue_2.createCommentVNode)("", true)
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_120, [
                    _cache[77] || (_cache[77] = (0, vue_2.createElementVNode)("label", null, "Email", -1)),
                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                        type: "email",
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = function ($event) { return ((medForm.value.pharmacyEmail) = $event); }),
                        placeholder: "Email"
                    }, null, 512), [
                        [vue_2.vModelText, medForm.value.pharmacyEmail]
                    ])
                ])
            ]));
        };
    }
});
